import { useSelector } from 'react-redux';
import { Order } from 'src/models';

export interface UseCumulativeOrderListSelectorReturnType {
  cumulativeOrderList: Order[];
  isCumulativeOrderListLoading: boolean;
  hasCumulativeOrderListError: boolean;
  cumulativeOrderListError?: string;
  cumulativeOrderListTotal: number;
}

const EMPTY_ORDERS: Order[] = [];

export const useCumulativeOrderListSelector = (): UseCumulativeOrderListSelectorReturnType => {
  const orderList: Order[] | undefined = useSelector((state: any) => state.orders.cumulativeList?.data?.data);
  const isOrderListLoading = useSelector((state: any) => Boolean(state.orders?.cumulativeList?.isLoading));
  const hasOrderListFailed: boolean = useSelector((state: any) => state.orders.cumulativeList?.__failed);
  const orderListError: string = useSelector((state: any) => state.orders.cumulativeList?.__message);
  const orderListTotal: number = useSelector((state: any) => state.orders.cumulativeList?.data?.total ?? 0);

  return {
    cumulativeOrderList: Array.isArray(orderList) ? orderList : EMPTY_ORDERS,
    isCumulativeOrderListLoading: isOrderListLoading,
    hasCumulativeOrderListError: hasOrderListFailed,
    cumulativeOrderListError: orderListError,
    cumulativeOrderListTotal: orderListTotal,
  };
};
